import { FlowDefinition } from "../../core/flows/FlowDefinition";
import { StepDefinition } from "../../core/flows/StepDefinition";
import { checkoutStepDefinition } from "../CheckoutPage/CheckoutStartup";
import { BookItAgainInitStepDeclaration } from "./Steps/BookItAgainInitStep";
import { BookItAgainTransition } from "./Transition/BookItAgainTransition";

export const bookItAgainStartupFlow = new FlowDefinition("BookItAgainFlow");

bookItAgainStartupFlow.addStep(BookItAgainInitStepDeclaration);
bookItAgainStartupFlow.addStep(checkoutStepDefinition);

bookItAgainStartupFlow.addLink("BookItAgainInit_Step", "CheckoutFlow")

bookItAgainStartupFlow.addTransition(BookItAgainTransition, "BookItAgainInit_Step")

bookItAgainStartupFlow.setStartStep("BookItAgainInit_Step");

export const bookItAgainStartupStepDefinition = new StepDefinition({
    stepName: "BookItAgainFlow",
    stepFlow: bookItAgainStartupFlow,
    contextIsolation: false
})
